import * as z from "zod/v4";

export const classifyClaimImage = {
  name: "classifyClaimImage" as const,
  input: z.object({ imageUrl: z.string(), verificationType: z.string() }),
  output: z.object({ category: z.string().nullable(), reason: z.string() }),
};
